module.exports = __webpack_public_path__ + "img/fiat-smartrace-autoshow-05.449313e6.jpg";